import {
  FETCH_ALL_TASKS,
  FETCH_ONE_TASK,
  CLEAR_ONE_TASK,
  SET_ONE_TASK,
  ONE_TASK_LOADING,
  FETCH_USER_TASKS,
  FETCH_MARKET_TASKS,
  TASKS_LOADING,
} from '../actions/tasks';

export default function(state = {}, action) {
  switch (action.type) {
    case TASKS_LOADING:
      return {
        ...state,
        isLoading: action.payload,
      };
    case FETCH_ALL_TASKS:
      return {
        ...state,
        tasks: action.payload,
      };
    case FETCH_ONE_TASK:
      return {
        ...state,
        oneTask: action.payload,
      };
    case CLEAR_ONE_TASK:
      return {
        ...state,
        oneTask: undefined,
      };
    case SET_ONE_TASK:
      return {
        ...state,
        oneTask: action.payload,
      };
    case ONE_TASK_LOADING:
      return {
        ...state,
        isOneTaskLoading: action.payload,
      };
    case FETCH_USER_TASKS:
      return {
        ...state,
        userTasks: action.payload,
      };
    case FETCH_MARKET_TASKS:
      return {
        ...state,
        marketTasks: action.payload,
      };
    default:
      return state;
  }
}
